console.warn(
  'You seem to be loading Decap CMS by fetching `dist/cms.js` from a CDN. That file is deprecated and will be removed in the next major release. Please use `dist/decap-cms.js` instead.',
);
